import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { internalLayersKeys } from './queryKeys';
import type { InternalLayer } from 'hooks/internalLayer/types';
import { layerNodesKeys } from 'hooks/layerNode/queryKeys';

export function useApproveInternalLayerMutation() {
  const queryClient = useQueryClient();

  return useMutation<InternalLayer, unknown, { internalLayerId: string }>({
    mutationFn: async ({ internalLayerId }) => {
      const resp = await axios.post<InternalLayer>(
        `${config.apiGateway.internal_layers}/${internalLayerId}/approve`
      );
      return resp.data;
    },
    onSuccess: () => {
      toast.success('Layer approved.');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: internalLayersKeys.all() });
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
  });
}
